import React from 'react';
import "./autocomplete.scss";
import { AutoComplete } from "primereact/autocomplete"

export const CustomAutoComplete = (props) => {
    return (
        <div className={`p-fluid p-inputgroup`} >
            {
                props.icon &&
                <span className="p-inputgroup-addon">
                    <i className={props.icon}></i>
                </span>
            }

            <AutoComplete
                id={props.id}
                className={props.className}
                value={props.value}
                suggestions={props.suggestions}
                completeMethod={props.completeMethod}
                field={props.field}
                placeholder={props.placeholder}
                multiple={props.multiple}
                onKeyPress={props.onKeyPress}
                onBlur={props.onBlur}
                onClick={props.onClick}
                onSelect={props.onSelect}
                onChange={props.onChange}
                dropdown={props.dropdown}
                onDropdownClick={props.onDropdownClick}
                panelStyle={{ height: props.scrollHeight }}
                style={props.light && { height: "38px", color: "white" }}
                inputStyle={props.light && { padding: "2px", fontSize: "12px" }}
            />
        </div>
    );
}